import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradingPeriodComp from "./routes/GradingPeriodComp";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "grading-periods",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "GradingPeriodWrapper" */ "./components/GradingPeriodWrapper"
      ),
      import(
        /* webpackChunkName: "admin-academicSetup" */ "./modules/GradingPeriodsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "gradingPeriods",
        reducer: reducer,
      });

      return component;
    })
  ),
  childRoutes: [GradingPeriodComp(store)],
});
